<template>
  <page-template page-id="reg-page" ref="super">

    <document-title :title="$tb('pages.sessionDetails.documentTitle')"></document-title>

    <template v-slot:before v-if="isTitlebarActive">
      <titlebar :text="$t('pages.sessionDetails.title')"></titlebar>
    </template>

    <div class="ui column">

      <brand-header :text="$t('pages.sessionDetails.header', {0: $store.state.appName})"
                    :has-extension="hasHeaderExtension"
                    :has-logo="hasBrandLogo">
      </brand-header>

      <p v-html="$t('pages.sessionDetails.subheader')"></p>

      <messages id="notifications" ref="postman"></messages>
        <div class="container">
          <div class="imageContent">
            <i class="desktop icon"></i>
          </div>
          <div class="textContent">
              <div class="content active session">
                <div class="grouped fields">
                  <div class="field" v-if="this.deviceData" >
                    <span><b>{{ $t('pages.sessionDetails.deviceInfo') }}</b>  {{ ': ' + this.deviceData  }}</span>
                  </div>
                  <div class="field" >
                    <p> {{$t('pages.sessionDetails.warning')}}</p>
                  </div>
                </div>
              </div>
        </div>
      </div>

      <div class="field">
        <button id="continue" type="submit" @click="onContinue"  class="ui fluid large primary submit button">
          {{$t('common.button.signOut')}}
        </button>
      </div>

    </div>

  </page-template>
</template>

<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import BrandHeader from '../components/BrandHeader.vue'
import Messages from '../components/Messages'
import { mixin } from '../js/ciam-mixin'
import { brand } from '../js/brand'

export default {
  components: {
    PageTemplate,
    Titlebar,
    BrandHeader,
    Messages
  },
  mixins: [mixin, brand],
  props: {
    uid: {
      type: String
    },
    deviceInfo: {
      type: String
    },
    sessionId: {
      type: String
    },
    rememberMeCode: {
      type: String
    }
  },
  data: function () {
    return {
      username: this.$store.state.username,
      language: this.$store.state.lang,
      showErrors: false,
      deviceData: this.deviceInfo ? this.deviceInfo : this.$store.state.deviceData,
      sessionKey: this.sessionId ? this.sessionId : null,
      rmbMeCode: this.rememberMeCode ? this.rememberMeCode : null
    }
  },
  methods: {
    onContinue: function () {
      if (!this.uid) return
      console.log(`Session details [sessionId=${this.sessionKey}] [rememberMeCode=${this.rmbMeCode}]`)
      this.$refs.postman.clear()
      this.showErrors = false

      this.$refs.super.startLoading()

      const payload = this.$api.payloads.buildRevokeSessionPayload(this.sessionKey, this.rmbMeCode)
      this.$api.logout.revokeSession(this.uid, payload, this.onSuccess, this.onFail)
    },
    onSuccess: function (resp) {
      this.handleRoutingResponse(resp)
    },
    onFail: function (response) {
      this.onAjaxError(response)
      this.$refs.super.stopLoading()
    },
    checkAuthorization: function () {
      if (!this.uid) {
        /* eslint-disable no-alert, no-console, no-debugger */
        console.debug('Opened this page in an unintended way!')
        $('.ui.form').form('add errors', [this.$t('pages.sessionDetails.notAllowed')])
      }
    }
  },
  mounted: function () {
    console.log(`Revoke User Session [uid=${this.uid}]`)
    this.$store.commit('deviceData', this.deviceInfo)
    this.checkAuthorization()
  }
}
</script>
<style scoped>
.container {
  display: flex;
  /* Enable flex wrap */
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
}
.imageContent,
.textContent {
  width: 50%;
  height: 150px;
  display: flex;
  /* Enable flex behavior for children */
  align-items: center;
  /* Center content vertically */
  justify-content: center;
  /* Center content horizontally */
}
.imageContent {
  width: 20%;
}
.textContent {
  width: 80%;
  flex-direction: column;
  border-bottom: 5px;
  align-items: flex-start;
}
.ui.form .grouped.fields .field {
  padding-left: 40px;
  text-align: left;
}
.content.active.session {
  padding: 0px 8px 8px 8px !important;
}
.imageContent i.icon, i.icons {
  cursor: pointer;
  font-size: xx-large;
  color: rgb(0, 0, 0);
  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
}
</style>
